// extracted by mini-css-extract-plugin
module.exports = {"component-wrapper":"two-col-m__component-wrapper__3Qddx","two-col__items":"two-col-m__two-col__items__2bPIj","full-height-card":"two-col-m__full-height-card__1KJrC"};